import React, { useCallback, useState } from 'react'
import { requestComplianceTextCheck } from '../lib/complianceTextCheck'
/**
 * 저장 검토 모달 등에 넣는 인라인 표현 리스크 점검(별도 오버레이 없음).
 */
export default function ComplianceTextCheckInline({ getText, label = '표현 리스크 점검 실행' }) {
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)

  const run = useCallback(async () => {
    const text = typeof getText === 'function' ? getText() : ''
    const body = String(text || '').trim()
    if (!body) {
      try { window?.toast?.show?.('점검할 문구가 없습니다. 소개·문구를 입력한 뒤 다시 시도해 주세요.', 'error') } catch { }
      return
    }
    setLoading(true)
    setResult(null)
    try {
      const out = await requestComplianceTextCheck(body)
      if (!out.ok && out.error === 'empty') {
        try { window?.toast?.show?.('점검할 문구가 없습니다.', 'error') } catch { }
        return
      }
      if (!out.ok) {
        try {
          window?.toast?.show?.(out.error === 'parse' ? '점검 결과를 해석할 수 없습니다.' : String(out.error), 'error')
        } catch { }
        return
      }
      setResult(out.result)
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || '점검에 실패했습니다.'
      try { window?.toast?.show?.(msg, 'error') } catch { }
    } finally {
      setLoading(false)
    }
  }, [getText])

  return (
    <div className="space-y-3">
      <button
        type="button"
        disabled={loading}
        onClick={run}
        className="w-full rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm font-semibold text-amber-950 hover:bg-amber-100 disabled:opacity-50"
      >
        {loading ? '점검 중…' : label}
      </button>

      {result ? (
        <div className="space-y-3 rounded-xl border border-slate-200 bg-slate-50/80 p-3">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="text-xs font-bold text-slate-900">점검 결과</div>
            <div className="text-[11px] text-slate-500">
              위험도 {result.riskLevel || 'LOW'} · 점수 {result.score ?? 0}
            </div>
          </div>
          {Array.isArray(result.findings) && result.findings.length > 0 ? (
            <div className="rounded border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-5 text-amber-950">
              <div className="mb-1 font-semibold">감지된 항목</div>
              {result.findings.map((f, idx) => (
                <div key={`risk-finding-${idx}`} className="border-t border-amber-200/70 py-1 first:border-t-0">
                  <strong>{f.keyword}</strong>
                  {' '}
                  · {f.category}: {f.reason}
                  {f.suggestion ? <div className="text-amber-800">제안: {f.suggestion}</div> : null}
                </div>
              ))}
            </div>
          ) : (
            <div className="rounded border border-emerald-100 bg-emerald-50 px-3 py-2 text-xs text-emerald-900">
              자동 점검 기준에서 특별히 걸린 표현이 없습니다.
            </div>
          )}
          <div className="rounded border border-slate-200 bg-white p-3">
            <div className="mb-1 text-[11px] font-semibold text-slate-500">수정 제안 문구</div>
            <p className="whitespace-pre-wrap text-sm leading-6 text-slate-800">{result.safeRewrite || '—'}</p>
          </div>
          {Array.isArray(result.checklist) && result.checklist.length > 0 ? (
            <div className="rounded border border-slate-200 bg-white px-3 py-2 text-xs leading-5 text-slate-600">
              {result.checklist.map((item) => <div key={String(item)}>· {String(item)}</div>)}
            </div>
          ) : null}
          <div className="rounded border border-indigo-100 bg-indigo-50 px-3 py-2 text-[11px] leading-relaxed text-indigo-950">
            본 결과는 키워드 기반 사전 점검일 뿐이며, 광고·모집 문구에 대한 심의필 발급을 대체하지 않습니다.
          </div>
        </div>
      ) : null}
    </div>
  )
}
